import { render, staticRenderFns } from "./draw_record.vue?vue&type=template&id=1850d559&scoped=true&"
import script from "./draw_record.vue?vue&type=script&lang=js&"
export * from "./draw_record.vue?vue&type=script&lang=js&"
import style0 from "./draw_record.vue?vue&type=style&index=0&id=1850d559&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850d559",
  null
  
)

export default component.exports